import {
  CheckOutlined,
  EditOutlined,
  StopOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useCrm_task_statuses } from "../../../../hooks";
import {
  completeTask,
  cancelRecord,
  deleteRecord,
} from "../../../../features/crm/activities/activitiesSlice";
import { useDispatch } from "react-redux";
import { Button, Tooltip, Modal } from "antd";
import { deleteConfirmMessage } from "../../../forms/formsFeedback";
import moment from "moment";
import { useIntl } from "react-intl";
const Actions = (props) => {
  const { record, onEditTask, onReload, branchId, entity, entityId } = props;
  const intl = useIntl();
  const [modal, contextHolder] = Modal.useModal();
  const dispatch = useDispatch();
  const statuses = useCrm_task_statuses();

  const canceledStatusId =
    statuses &&
    statuses.length > 0 &&
    statuses.filter((i) => i.name === "canceled")[0].id;

  const isCanceled = record && record.status_id === canceledStatusId;
  const isDeleted = record && record.is_deleted;
  const isTask = record && record.type === "task";

  const onCompleteTask = async () => {
    const completeStatusId = statuses.filter((i) => i.name === "completed")[0]
      .id;
    const activity = {
      id: record.id,
      status_id: completeStatusId,
      due_date: moment().format(),
    };
    const params = {
      activity,
      entity,
      entityId,
      activityType: "tasks",
      scope: `branches/${branchId}`,
    };
    const action = await dispatch(completeTask(params));
    if (!action.error) {
      onReload && onReload(); // Call reload after successful completion
    }
  };

  const onCancelActivity = () => {
    const title = intl.formatMessage({
      id: "app.forms.activities.cancelConfirmTitle",
    });
    const content =
      intl.formatMessage({
        id: "app.forms.activities.cancelConfirmContent",
      }) +
      " " +
      record.subject +
      "?";
    modal.confirm({
      title: title,
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk() {
        return onConfirm(record);
      },
      onCancel() {},
    });
  };

  const onConfirm = async () => {
    const cancelStatusId = statuses.filter((i) => i.name === "canceled")[0].id;
    const activityType = "tasks";
    const activity = {
      id: record.id,
      status_id: cancelStatusId,
    };
    const params = {
      activity,
      entity,
      entityId,
      activityType,
      scope: branchId ? `/branches/${branchId}` : "",
    };
    const action = await dispatch(cancelRecord(params));
    if (!action.error) {
      onReload && onReload(); // Call reload after successful cancellation
    }
  };

  const onDeleteActivity = () => {
    deleteConfirmMessage(
      intl,
      record.subject,
      "activities",
      record,
      onConfirmDelete,
      modal
    );
  };

  const onConfirmDelete = async () => {
    const activityId = record.id;
    const activityType = record.type === "event" ? "events" : "tasks";
    const params = {
      activityId,
      entity,
      entityId,
      activityType,
      scope: branchId ? `/branches/${branchId}` : "",
    };
    const action = await dispatch(deleteRecord(params));
    if (!action.error) {
      onReload && onReload(); // Call reload after successful deletion
    }
  };

  const MarkAsCompleted = () =>
    record.status.name === "completed" ? null : (
      <Tooltip
        title={intl.formatMessage({
          id: "app.actions.mark_as_completed",
        })}
      >
        <Button
          type="text"
          size="small"
          icon={<CheckOutlined style={{}} />}
          onClick={onCompleteTask}
        />
      </Tooltip>
    );
  return (
    <div className="task_actions">
      {contextHolder}
      <MarkAsCompleted />
      <Tooltip
        title={intl.formatMessage({
          id: "app.actions.edit_task",
        })}
      >
        <Button
          type="text"
          size="small"
          icon={<EditOutlined style={{}} />}
          onClick={() => onEditTask(record)}
        />
      </Tooltip>

      {!isCanceled && (
        <Tooltip
          title={intl.formatMessage({
            id: "app.activities.cancel_activity",
          })}
        >
          <Button
            type="text"
            size="small"
            icon={<StopOutlined style={{ color: "red" }} />}
            onClick={onCancelActivity}
          />
        </Tooltip>
      )}
      {!isDeleted && !isTask && (
        <Tooltip
          title={intl.formatMessage({
            id: "app.activities.cancel_activity",
          })}
        >
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined style={{ color: "red" }} />}
            onClick={onDeleteActivity}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default Actions;
